const names = { en: 'English', es: 'Español', ko: '한국어', ar: 'العربية', ml: 'മലയാളം' };

function setLanguageCookie(value) {
  const host = window.location.hostname;
  // Google can create its own parent-domain cookie as well as a host cookie.
  // Clear every reachable scope before setting the selected preference.
  const labels = host.split('.');
  const domains = ['', ...labels.map((_, i) => labels.slice(i).join('.')).filter(domain => domain.includes('.'))];
  const parts = window.location.pathname.split('/').filter(Boolean);
  const paths = new Set(['/', ...parts.flatMap((_, i) => {
    const path = '/' + parts.slice(0, i + 1).join('/');
    return [path, path + '/'];
  })]);
  for (const path of paths) for (const domain of domains) {
    const expired = `googtrans=;path=${path};max-age=0;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = expired + (domain ? `;domain=${domain}` : '');
    if (domain) document.cookie = `${expired};domain=.${domain}`;
  }
  if (value) document.cookie = `googtrans=${value};path=/`;
}

export function prepareLanguagePreference() {
  try {
    if (sessionStorage.getItem('jil-reset-english')) {
      setLanguageCookie('');
      sessionStorage.removeItem('jil-reset-english');
    }
  } catch { /* Cleared cookies still restore English when browser storage is unavailable. */ }
}

export function initializeLanguages(root, on) {
  const menu = root.querySelector('#jil-id-lang-187');
  const button = root.querySelector('#jil-id-lang-btn-188');
  const label = root.querySelector('#jil-id-lang-label-189');
  const options = [...menu.querySelectorAll('[data-lang]')];
  let disposed = false;
  let retry;
  const mark = code => {
    label.textContent = names[code];
    options.forEach(option => option.classList.toggle('jil-lang-active-85', option.dataset.lang === code));
  };
  const toggle = open => {
    menu.classList.toggle('jil-lang-open-82', open);
    button.setAttribute('aria-expanded', String(open));
  };
  on(button, 'click', event => { event.stopPropagation(); toggle(!menu.classList.contains('jil-lang-open-82')); });
  on(document, 'click', () => toggle(false));
  on(document, 'keydown', event => { if (event.key === 'Escape') toggle(false); });

  const apply = (code, attempts = 0) => {
    if (disposed) return;
    const combo = document.querySelector('.goog-te-combo');
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event('change', { bubbles: true }));
      mark(code);
    } else if (attempts < 20) retry = setTimeout(() => apply(code, attempts + 1), 250);
    else {
      setLanguageCookie(''); mark('en');
      console.warn('The original Google Translate service is unavailable. The page remains in English.');
    }
  };
  options.forEach(option => on(option, 'click', () => {
    clearTimeout(retry);
    const code = option.dataset.lang;
    toggle(false);
    if (code === 'en') {
      const translated = document.documentElement.matches('.translated-ltr, .translated-rtl') || document.cookie.includes('googtrans=/en/');
      setLanguageCookie(''); mark('en');
      if (translated) {
        try { sessionStorage.setItem('jil-reset-english', 'true'); } catch { /* Cookies already cleared. */ }
        window.location.reload();
      }
    } else { setLanguageCookie(`/en/${code}`); apply(code); }
  }));
  const saved = (document.cookie.match(/googtrans=\/en\/([a-z]{2})/) || [])[1];
  mark(names[saved] ? saved : 'en');

  return () => { disposed = true; clearTimeout(retry); };
}